function changeCurrency(){
    if( jQuery('input[name=currency_code]' ).attr('value') == "DKK" ){

        console.log('DKK');
        jQuery('.currency-container').text('DKK');

    }else if( jQuery('input[name=currency_code]' ).attr('value') == "SEK" ){
        console.log('SEK');
        jQuery('.currency-container').text('SEK');
    }else if( jQuery('input[name=currency_code]' ).attr('value') == "EUR" ){
        console.log('SEK');
        jQuery('.currency-container').text('EUR');
    }
}
setTimeout(() => {
    //changeCurrency();
    setTimeout(() => {
       // changeCurrency();
    }, 1000);
}, 300);

// if(){

// }